export class TorchKpiOshaInjuryRate {
  id: number;
  injuryDate: Date;
  injuryRateFytd: number;
  injuryRateTarget: number;
}
